import React from 'react';
import { Chip, Stack } from '@mui/material';
import { scribeTokens } from '../../../components/scribe/tokens';

// One look for every client-dashboard section (Cath, 2026-10-29: no mixed
// colours, fonts or controls on the same page).
export const DASHBOARD_COLORS = {
  title: '#14234B', text: '#374151', muted: '#5B6675', border: '#E3E9EE',
  // Brand teal from the shared Scribe tokens (same as the Ask Sophie button).
  accent: scribeTokens.colors.brand, accentHover: scribeTokens.colors.brandHover, chipIdle: '#F1F4F7', chipIdleHover: '#E3E9EE',
};

export const sectionCardSx = { p: 2.5, borderRadius: 2, border: `1px solid ${DASHBOARD_COLORS.border}`, bgcolor: '#FFFFFF' };
export const sectionTitleSx = { fontWeight: 700, fontSize: 17, color: DASHBOARD_COLORS.title };
export const clickableTileSx = {
  p: 1.5, border: `1px solid ${DASHBOARD_COLORS.border}`, borderRadius: 1.5, bgcolor: '#FFFFFF', cursor: 'pointer',
  '&:hover, &:focus-visible': { borderColor: scribeTokens.colors.brand, outline: 'none' },
};
export const trendHintSx = { fontSize: 12, fontWeight: 600, color: DASHBOARD_COLORS.accent, whiteSpace: 'nowrap' };

// The period switch used by chat summaries and wellness alike.
export function RangeChips({ options, value, onChange, label }) {
  return (
    <Stack direction="row" spacing={0.75} flexWrap="wrap" useFlexGap role="group" aria-label={label}>
      {options.map((option) => {
        const active = value === option.key;
        return (
          <Chip key={option.key} label={option.label} size="small" clickable onClick={() => onChange(option.key)} aria-pressed={active}
            sx={{ fontWeight: 600, bgcolor: active ? DASHBOARD_COLORS.accent : DASHBOARD_COLORS.chipIdle, color: active ? '#FFFFFF' : DASHBOARD_COLORS.text,
              '&:hover': { bgcolor: active ? DASHBOARD_COLORS.accentHover : DASHBOARD_COLORS.chipIdleHover } }} />
        );
      })}
    </Stack>
  );
}
